/* eslint-disable */
import React from 'react';
import sortCaret from 'components/Table/Others/sortCaret';
import ActionsFormatter from 'components/Table/Fomatters/actionsFormatter';
import ProgressBar from 'components/Progress/ProgressBar';

// link
import { Box, Button, Flex, Link, IconButton } from '@chakra-ui/react';
import { viewDateAndTime } from 'utils/date';
import { viewMobile } from 'utils/number';
import { ACCEPTED_STATE } from 'constants/marketplace-default';
import { viewAmount, viewPercentage } from 'utils/number';

// mixpanel image 
import mixpanel from 'assets/img/mixpanel.png';

export const getTransactionTableHeader = () => {
    return [
        {
            text: 'App Id',
            dataField: 'applicationId',
            formatter: (cell, row) => {
                return (
                    <Link href={'/organization/transaction/' + row._id} color={'brand.500'}>
                        {cell}
                    </Link>
                );  
            },
            headerStyle: {
                width: "165px"
            }
        },
        {
            text: 'Mortgage Type',
            dataField: 'loanPurpose',
            formatter: (value) => {
                return (
                    <>
                        { value }
                    </>
                );
            }
        },
        {
            text: 'Amount',
            dataField: 'loanAmount',
            formatter: (value) => {
                return (
                    <>
                        { viewAmount(value) }
                    </>
                );
            }
        },
        {
            text: 'Credit Score',
            dataField: 'metaData.creditScore',
            formatter: (value) => {
                return (
                    <>
                        { value }
                    </>
                );
            },
            headerStyle: {
                width: '80px'
            }
        },
        {
            text: 'Debt Ratio',
            dataField: 'property.debtRatio',
            formatter: (value) => {
                return (
                    <>
                        { viewPercentage(value) }
                    </>
                );
            },
            headerStyle: {
                width: '85px'
            }
        },
        {
            text: 'Created At',
            dataField: 'createdAt',
            formatter: (value) => {
                return viewDateAndTime(value);
            }
        },
        {
            text: 'Status',
            dataField: 'applicationStatus',
            formatter: (value) => {     
                switch(value) {
                    case 'CREATED':
                        return (
                            <p className='success-text'>
                                CREATED
                            </p>
                        );
                    case 'INPROGRESS':
                        return (
                            <p className='success-text'>
                                IN PROGRESS
                            </p>
                        );
                    case 'BIDDING':
                        return (
                            <p>
                                BIDDING
                            </p>
                        );
                    case 'FUNDED':
                        return (
                            <p>
                                FUNDED
                            </p>
                        );
                    default:
                        return value;   
                }
            }
        },
        {
            text: 'Action',
            dataField: 'action',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    
                    <Flex gap={2}>
                        <Box>
                            <Link href={'/organization/transaction/' + row._id} color={'brand.500'}>
                                <Button size="xs" colorScheme="blue">
                                    View Details
                                </Button>
                            </Link>
                        </Box>
                        
                        {/* <Box>
                            <Link href={'/organization/transaction/transaction/' + cell} color={'brand.500'}>
                                <Button size="xs" colorScheme="red">
                                    Reject
                                </Button>
                            </Link>
                        </Box> */}
                    </Flex>
                );
            } ,
            headerStyle: {
                width: '100px'
            }
        }

    ]
}

export const getCompanyTableHeader = ({ tableActions })=>{
    return [
        {
            text: 'Ticket ID',
            dataField: 'ticketId',
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <Link href={'/organization/approvals/view-request/' + row._id} color={'brand.500'}>
                        {cell}
                    </Link>
                );
            } ,
            formatExtraData: tableActions
        },
        {
            text: 'Company Name',
            dataField: 'companyName',
            sort: false,
            sortCaret,
            formatter: (value,row)=>{
                return (
                    <Link href={'/organization/user/lender/details/' + row?.companyId} color={'brand.500'}>
                        {value}
                    </Link>
                );
            }
        },
        {
            text: 'Type',
            dataField: 'type',
            sort: false,
            sortCaret
        },

        {
            text: 'Status',
            dataField: 'status',
            sort: true,
            sortFunc: (a, b, order, dataField, rowA, rowB) => {
                if (a === 'PENDING') {
                    return -1;
                }
                return 1;
            }
        },
        {
            text: 'Created On',
            dataField: 'createdAt',
            formatter: (value) => {
                return viewDateAndTime(value);
            }

        },
        {
            text: 'Action',
            dataField: '_id',
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                if (row.status !== 'PENDING') {
                    return (
                        <Link href={'/organization/approvals/view-request/' + cell} color={'brand.500'}>
                        View Details
                        </Link>
                    );
                }
                return (<ActionsFormatter cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData}/>);
            } ,
            formatExtraData: tableActions
        }

    ];
};
export const allcompaniesHeader = ({ tableActions })=>{
    return [
        {
            text: 'Company Id',
            dataField: 'companyId',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <Link href={'/organization/user/lender/details/' + row._id} color={'brand.500'}>
                        {cell}
                    </Link>
                );
            }
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (value,row)=>{
                return (
                    <>
                        { value }
                    </>
                );
            }
        },
        {
            text: 'NMLS',
            dataField: 'NMLS',
            sort: true

        },
        {
            text: 'Created On',
            sortCaret,
            dataField: 'createdAt',
            sort: false,
            formatter: (value)=>{
                return viewDateAndTime(value);
            }
        },

        {
            text: 'On Boarding',
            dataField: 'onboardingPercent',
            sort: false,
            headerStyle: ()=>{
                return { width: '150px ' };
            },
            formatter: (cell)=>{
                return (
                    <>
                        <ProgressBar value={cell.toString()}/>
                    </>
                );
            }
        },
        {
            text: 'Status',
            dataField: 'isActive',
            sortCaret,
            sort: false,
            formatter: (value) => {
                return value === true
                    ? <p className='success-text'>
                        ACTIVE
                    </p>
                    : <p className='danger-text'>
                        BLOCK
                    </p>;
            }

        },
        {
            text: 'Action',
            dataField: 'updatedAt',
            formatter: (value, row)=>{
                return (
                    <>
                    <IconButton
                aria-label="View on Mixpanel"
                icon={<img src={mixpanel} alt="Mixpanel" style={{ width: '1.5rem', height: '1.5rem' }} />}
                variant="ghost"
                onClick={() => window.open(`https://mixpanel.com/project/3702032/view/4200228/app/profile#distinct_id=${row?._id}`, '_blank', 'noreferrer')}
            />

                    <Link href={'/organization/user/lender/stats/' + row._id} color={'brand.500'}>
View Stats
                    </Link>
                    </>
                );
            }
        }

    ];
};
export const allRealtorHeader = ({ tableActions })=>{
    return [
        {
            text: 'Id',
            dataField: 'realtorId',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <Link href={'/organization/user/realtor/' + row._id} color={'brand.500'}>
                        {cell || ''}
                    </Link>
                );
            }
        },
        {
            text: 'Email',
            dataField: 'ContactPointEmailValue'
        },

        {
            text: 'First Name',
            dataField: 'FirstName',
            formatter: (value,row)=>{
                return (
                    <>
                        { value }
                    </>
                );
            }
        },
        {
            text: 'Last Name',
            dataField: 'LastName'
        },
        {
            text: 'On Board Type',
            dataField: 'onboardFrom'
        },
        {
            text: 'Status',
            dataField: 'accountStatus',
            sortCaret,
            formatter: (value, row) => {
                if (row?.isSuspendedByAdmin) {
                    return (
                        <p className='danger-text'>
                            SUSPENDED
                        </p>

                    );
                } else {
                    return value === true
                        ? <p className='success-text'>
                            ACTIVE
                        </p>
                        : <p className='danger-text'>
                            BLOCK
                        </p>;
                }
            },
            sort: true

        },
        {
            text: 'Created On',
            dataField: 'createdAt',
            sort: true ,
            sortCaret,
            formatter: (value)=>{
                return viewDateAndTime(value);
            }
        },
        {
            text: 'Action',
            dataField: 'updatedAt',
            formatter: tableActions
        }

    ];
};

export const getusersHeader = ({ tableActions })=>{
    return [
        {
            text: 'Email',
            dataField: 'ContactPointEmailValue',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return cell;
            }

        },
        {
            text: 'Mobile No',
            dataField: 'ContactPointTelephoneValue',
            formatter: (value,row)=>{
                return viewMobile(row);
            }
        },
        {
            text: 'NMLS',
            dataField: 'NMLS'
        },
        {
            text: 'Branch Name',
            dataField: 'branchId',
            formatter: (value , row)=>{
                return row?.branchId?.[0]?.branchName || row?.branchId?.[0];
            }

        },
        {
            text: 'Status',
            dataField: 'accountStatus',
            sortCaret,
            formatter: (value)=>{
                return value === true
                    ? <p className='success-text'>
ACTIVE
                    </p>
                    : <p className='danger-text'>
                BLOCK
                    </p>;
            },
            sort: true

        },
        {
            text: 'Created On',
            dataField: 'createdAt',
            sortCaret,
            formatter: (value)=>{
                return viewDateAndTime(value);
            }
        },
        {
            text: 'Actions',
            dataField: '_id',
            sortCaret,
            formatter: (value)=>{
                return (
                    <Link href={'/organization/user/lender/user/' + value } color={'brand.500'}>
            View Details
                    </Link>
                );
            }
        }

    ];
};

export const InvitedUsersHeader = ({ tableActions })=>{
    return [
        {
            text: 'Email',
            dataField: 'email',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return cell;
            },
            sort: true,
            sortCaret,
            formatExtraData: tableActions
        },
        {
            text: 'Type',
            dataField: 'invitedToRole',
            sort: true,
            sortCaret
        },
        {
            text: 'Status',
            dataField: 'status',
            sortCaret,
            sort: true,
            formatter: (value, row) => {
                if (value === ACCEPTED_STATE) {
                    return (
                        <p className='success-text'>
                            ACCEPTED
                        </p>
                    );
                }
                return value;
            }
        },

        {
            text: 'Sent On',
            dataField: 'updatedAt',
            sortCaret,
            sort: true ,
            formatter: (value)=>{
                return viewDateAndTime(value);
            }
        },
        {
            text: 'Action',
            dataField: '_id',
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                 return (<ActionsFormatter cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData}/>);
           
            } ,
            formatExtraData: tableActions

        }

    ];
};


